import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function datetimeRangeRenderer({
  value,
  isOldValue,
}: RenderProps) {
  const v = value as { start?: string; end?: string } | undefined;
  const start = v?.start || "—";
  const end = v?.end || "—";
  return (
    <ValueDisplay isOldValue={isOldValue}>
      {start} {" -> "} {end}
    </ValueDisplay>
  );
}
